import React from 'react';
import Spinner from '@guestyci/foundation/Spinner';
import TextField from '@guestyci/foundation/TextField';
import Col from '@guestyci/foundation/Col';

const Loader = ({ text }) => {
  return (
    <Col spacing={4}>
      <div>
        <Spinner size={30} color="white" />
      </div>
      <TextField style={{ fontSize: '1.2rem' }} color="white">
        {text}
      </TextField>
    </Col>
  );
};

export default Loader;
